import { memoize } from '@exodus/basic-utils';
import { createSelector } from 'reselect';
const EMPTY = new Set();
const selectorFactory = (availableAssetNamesByWalletAccountSelector, enabledAssetsSelector) => memoize((walletAccount) => createSelector(availableAssetNamesByWalletAccountSelector, enabledAssetsSelector, (availableAssetsByWalletAccount, enabledAssets) => {
    const availableAssets = availableAssetsByWalletAccount[walletAccount];
    if (!availableAssets)
        return EMPTY;
    return new Set([...availableAssets].filter((asset) => enabledAssets[asset]));
}));
const createEnabledAssetsByWalletAccountSelectorDefinition = {
    id: 'createEnabledAssetsByWalletAccount',
    selectorFactory,
    dependencies: [
        { selector: 'availableAssetNamesByWalletAccount' },
        { module: 'enabledAssets', selector: 'data' },
    ],
};
export default createEnabledAssetsByWalletAccountSelectorDefinition;
